export default [
  {
    account_id: 'WBD0F370D53',
    contributions: '45800.0',
    balance: '49332.28',
    ror: 4.314959868150693,
    created_at: '2021-06-20',
    account_type_name: 'TFSA',
    portfolio_model_name: 'Growth',
    beneficiaries: [
      {
        name: 'Spouse Test',
        percentage_payable: null,
        relationship: 'Spouse',
        social_insurance_number: '',
        address: 'Street Test, City, BC, A1B2C3, CAN'
      }
    ],
    contingent_beneficiaries: [
      {
        name: 'Father Test',
        relationship: 'Father',
        social_insurance_number: '000000000',
        address: 'Test Avenue, Vancouver, BC, V5G 3R6'
      },
      {
        name: 'Mother Test',
        relationship: 'Mother',
        social_insurance_number: '',
        address: 'Test Street, Vancouver, BC, V7P 3P7'
      }
    ]
  },
  {
    account_id: 'WBD09E4BBFC',
    contributions: '124000.0',
    balance: '133602.85',
    ror: 4.22672424383734,
    created_at: '2021-06-20',
    account_type_name: 'RRSP',
    portfolio_model_name: 'Safety',
    beneficiaries: [
      {
        name: 'Joe Smoe',
        percentage_payable: '50',
        relationship: 'Father',
        social_insurance_number: '795727866',
        address: '123 Main Street, Vancouver, BC, A1B 2C3'
      },
      {
        name: 'Jane Doe',
        percentage_payable: '20',
        relationship: 'Mother',
        social_insurance_number: '',
        address: '321 Side Street, Vancouver, BC, C3B 2A1'
      },
      {
        name: 'Von Neuman',
        percentage_payable: '15',
        relationship: 'Brother',
        social_insurance_number: '000000000',
        address: '12345 Sibling Test, Toronto, Ontario'
      },
      {
        name: 'James Bond',
        percentage_payable: '10',
        relationship: 'Friend',
        social_insurance_number: '',
        address: '007 Somewhere Street, London, 1234512, UK'
      },
      {
        name: 'Bob Smith',
        percentage_payable: '5',
        relationship: 'Cousin',
        social_insurance_number: '958700825',
        address: null
      }
    ],
    contingent_beneficiaries: []
  },
  {
    account_id: 'WBD09E7H234',
    contributions: '185000.0',
    balance: '200160.25',
    ror: 4.48672424383734,
    created_at: '2021-06-20',
    account_type_name: 'GRRSP',
    portfolio_model_name: 'Growth',
    beneficiaries: [
      {
        name: 'Spouse Test',
        percentage_payable: 75,
        relationship: 'Spouse',
        social_insurance_number: '987654321',
        address: 'Street Test, City, BC, A1B2C3, CAN'
      },
      {
        name: 'Son Test',
        percentage_payable: 25,
        relationship: 'Son',
        social_insurance_number: '987654333',
        address: 'Street Test, City, BC, A1B2C3, CAN'
      }, 
    ],
    contingent_beneficiaries: []
  }
];